const A = "/assets";

export const IMAGES = {
  opsLogo: `${A}/ops-logo-t.png`,
  opsLogoPlain: `${A}/ops-logo.png`,
  evkLogo: `${A}/evk-logo-t.png`,
  mapMaranhao: `${A}/map-maranhao.png`,
  mapBay: `${A}/map-bay.png`,
  mapSatellite: `${A}/map-satellite.png`,
  terminalFront: `${A}/terminal-front.png`,
  terminalAerial: `${A}/terminal-aerial.png`,
  aerialWide: `${A}/terminal-aerial-wide.webp`,
  quayVessel: `${A}/terminal-quay-vessel.webp`,
  terminalOverview: `${A}/terminal-overview.webp`,
  terminalTop: `${A}/terminal-top.webp`,
  bunkerDeck: `${A}/bunker-deck.png`,
  vesselSea: `${A}/vessel-sea.png`,
  lithoBulk: `${A}/lithothamnium.jpg`,
  stsOperation: `${A}/sts-operation.png`,
  containerShip: `${A}/container-ship.jpg`,
};

export const CONTACT_EMAIL = "comercial@openportservices.com.br";

export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;
